/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {Injector} from '@angular/core';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';
import {NetworkProfileResource} from './network-profile.resource.token';
import {LOCAL_USER_PROFILE} from '../../../session/session-profile.tokens';

export {NetworkProfileResource} from './network-profile.resource.token';

function transformRequest(data: any): any {
  const transformed = _.cloneDeep(data);
  if (_.isPlainObject(transformed.profile)) {
    transformed.profile = _.mapValues(transformed.profile, (value: any) => _.isObject(value) ? JSON.stringify(value) : value);
  }
  return transformed;
}

function transformResponse(data: any): any {
  if (_.isPlainObject(_.get(data, 'profile'))) {
    data.profile = _.mapValues(data.profile, (value: any) => {
      if (!_.isString(value)) {
        return value;
      }
      try {
        return JSON.parse(value);
      } catch (_err) {
        return value;
      }
    });
  }
  return data;
}

// LocalNetworkProfile depends on NetworkProfileResource, and LocalUserProfile sits behind
// LocalNetworkProfile. Do not import LocalUserProfile here — that creates an ES-module cycle.
// Resolve via LOCAL_USER_PROFILE token instead.
export function createNetworkProfileResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  injector: Injector
): any {
  return createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'networkprofiles',
    () => injector.get(LOCAL_USER_PROFILE),
    'networkProfile',
    undefined,
    {transformRequest, transformResponse}
  );
}

export const networkProfileResourceProvider = {
  provide: NetworkProfileResource,
  useFactory: createNetworkProfileResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, Injector]
};

